import { mapMutations, mapActions } from 'vuex'
import { getKey, setKey } from '../../assets/utils'
export default {
  data () {
    return {
    }
  },
  beforeRouteEnter (from, to, next) {
    if (to.path === '/repayment') {
      next((vm) => {
        vm.buriedPoint(1)
        window.history.go(-1)
      })
    } else {
      next((vm) => {
        vm.buriedPoint(1)
      })
    }
  },
  beforeDestroy () {
    this.buriedPoint(0)
  },
  async created () {
    const { token } = this.$route.query
    // 调用接口 
    const item = await this.getWeiboPermissions({ token }) // 授权
    if (item.success) {
      setKey('successUrl', item.data.successUrl)
      this.setUserInfo(item.data)
      this.nextStep()
    } else {
      this.$message('授权失败')
      window.history.go(-1)
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapMutations('user', ['setUserInfo']),
    ...mapActions('user', ['getWeiboPermissions']),
    // 判断用户下一步走什么流程
    async nextStep () {
      document.title = '我要还款'
      this.$router.replace({ path: '/repayment', query: { isQueryChannel: 'T' } })
    },
    /**
     * @description 由于产品需要在args里面添加userId参数，所以将页面自动埋点修改为这里来添加
     * @param {}} userId 
     * @param {*} index 
     */
    buriedPoint (visible) {
      this.$report({
        id: 10002,
        args: {
          channel: this.$route.query.channel || getKey('channel') || 'official',
          screen: 'page_small_flower',
          userId: getKey('userInfo', 'userId'),
          visible: visible
        }
      })
    }
  },
  render () {
    return <div/>
  }
}